<template>
    <div>
      <v-toolbar class="pb-10 blue accent-2" extension-height="1" app>
        <v-icon v-if="isLoggedIn"  @click="expandonHover = !expandohHover" x-large>list</v-icon>
          <h1 class="ml-10">VEC CSE B 2017-21</h1>
          <v-spacer></v-spacer>
        <v-btn v-if="!isLoggedIn" class="mr-4" link to="/r">Register</v-btn>
        <v-btn v-if="isLoggedIn" class="mr-4" link to="/d">Dashboard</v-btn>
        <v-btn v-if="isLoggedIn" v-on:click="logout" >Log out</v-btn>
        </v-toolbar>
        <v-navigation-drawer v-if="isLoggedIn" id="navi" v-model="expandonHover"  class="blue" app clipped>
          <v-layout column align-center>
            <v-flex class="mt-5">
                <v-avatar size="100">
                    <img src="/avatar-1.png" alt="">
                </v-avatar>
                <p class="white--text subheading mt-1">
                    {{currentUser}}
                </p>
            </v-flex>    
        </v-layout> 
         <v-list>
          <v-list-item v-for="link in links" :key="link.text" link :to="link.route">
              <v-list-item-action>
                  <v-icon left class="white--text">{{link.icon}}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                  <v-list-item-title class="white--text">{{link.text}}</v-list-item-title>
              </v-list-item-content>
          </v-list-item>
        </v-list>
        </v-navigation-drawer>
    </div>    
</template>

<script>
import {auth} from '../components/firebaseinit'
export default {
  props:{
    expandonHover:{
      type:Boolean
    }
  },
  data(){
    return {
      links:[
             {icon:'dashboard',text:"Dashboard",route:'/d'},
             {icon:'person',text:'Class',route:'/c'},
             {icon:'folder',text:'Notes',route:'/n'}
         ],
         isLoggedIn:false,
         currentUser:false
    }
  },
  methods:{
    logout:function(){
      auth.signOut().then(() => {
        console.log("baby")
        this.$router.go(this.$router.push('/'));
      })
    }
  },
  created(){
    if(auth.currentUser){
      this.isLoggedIn=true
      this.currentUser=auth.currentUser.email
    }
  }
}
</script>

<style >
#navi{
  border-top-right-radius: 5%;
  border-bottom-right-radius: 5%;
}

</style>